import { render, staticRenderFns } from "./xnblist.vue?vue&type=template&id=657f3b75&scoped=true&"
import script from "./xnblist.vue?vue&type=script&lang=js&"
export * from "./xnblist.vue?vue&type=script&lang=js&"
import style0 from "./xnblist.vue?vue&type=style&index=0&id=657f3b75&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657f3b75",
  null
  
)

export default component.exports